import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const pageHeader = document.querySelector('.page-header');
const headings = document.querySelectorAll(
	// eslint-disable-next-line max-len
	'.wp-block-heading, .animated-title, .wp-block-media-text__content > *, .ghostkit-col-content > *:not(.gform_confirmation_wrapper, .gform_anchor), .animated-content > *'
);

if (headings) {
	gsap.registerPlugin(ScrollTrigger);

	headings.forEach(heading => {
		gsap.to(heading, {
			opacity: 1,
			duration: 0.8,
			delay: 0.1,
			stagger: 0.5,
			y: 0,
			ease: 'expoScale(10,2.5,power2.out)',
			scrollTrigger: {
				trigger: heading,
				start: 'top 95%',
				end: 'bottom 100%',
				toggleActions: 'play none play reverse',
				markers: false,
				toggleClass: 'active',
			},
		});
	});
	(function ($) {
		$(document).on('gform_confirmation_loaded', () => {
			ScrollTrigger.refresh(true);
		});
	})(window.jQuery);
}

if (pageHeader) {
	gsap.registerPlugin(ScrollTrigger);

	const pageHeaderContent = pageHeader.querySelectorAll('.page-header__content > *');
	const pageHeaderImageWrapper = pageHeader.querySelector('.page-header__image-wrapper');
	const pageHeadeImage = pageHeader.querySelector('.page-header__image');

	gsap.to(pageHeaderContent, {
		opacity: 1,
		duration: 0.8,
		y: 0,
		delay: 0.1,
		ease: 'power2.inOut',
		scrollTrigger: {
			trigger: pageHeader,
			start: 'top 100%',
			markers: false,
		},
	});

	if (pageHeadeImage && pageHeaderImageWrapper) {
		gsap.to(pageHeadeImage, {
			duration: 1,
			scale: 1.1,
			ease: 'linear',
			scrollTrigger: {
				trigger: pageHeader,
				start: 'top top',
				end: `top+=${pageHeaderImageWrapper.offsetHeight * 0.5}`,
				scrub: true,
				markers: false,
			},
		});
	}
}

const homeHeader = document.querySelector('.home-header');
const getCookie = cname => {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return false;
};
if (homeHeader) {
	gsap.registerPlugin(ScrollTrigger);

	const homeHeaderContent = homeHeader.querySelectorAll('.home-header__content > *');
	let delay = 0.2;
	if (!getCookie('intro')) {
		delay = 0.75;
	}
	gsap.to(homeHeaderContent, {
		opacity: 1,
		duration: 0.8,
		y: 0,
		stagger: 0.4,
		delay,
		ease: 'power3.inOut',
		scrollTrigger: {
			trigger: homeHeader,
			start: 'top 100%',
			markers: false,
		},
	});
}
